import React from 'react';
import { Check } from 'lucide-react';
import { illustrationStyles } from '../../data/templateCustomizationSchemas';

export const StylePicker = ({ selectedStyle, onChange, styles, title, subtitle }) => {
  const items = styles || illustrationStyles;
  return (
    <div data-testid="style-picker" className="space-y-4">
      <div>
        <h3 className="font-sans font-semibold text-stone-800 text-sm">{title || 'Illustrasjonsstil'}</h3>
        <p className="text-xs font-sans text-stone-500 mt-0.5">{subtitle || 'Choose the style that fits best'}</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {items.map((style) => (
          <button
            key={style.id}
            type="button"
            data-testid={`style-option-${style.id}`}
            onClick={() => onChange(style.id)}
            className={`group relative rounded-2xl overflow-hidden border-2 transition-all duration-200 ${
              selectedStyle === style.id
                ? 'border-primary ring-2 ring-primary/20 shadow-lg'
                : 'border-stone-200 hover:border-stone-400 hover:shadow-md'
            }`}
          >
            {/* Thumbnail */}
            <div className="aspect-square relative overflow-hidden">
              <img
                src={style.thumbnail}
                alt={style.name}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
              {selectedStyle === style.id && (
                <div className="absolute inset-0 bg-primary/10 flex items-center justify-center">
                  <div className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center shadow-lg">
                    <Check className="w-5 h-5" />
                  </div>
                </div>
              )}
            </div>

            {/* Label */}
            <div className="p-2.5 bg-white">
              <p className={`text-xs font-sans font-semibold truncate ${
                selectedStyle === style.id ? 'text-primary' : 'text-stone-700'
              }`}>
                {style.name}
              </p>
              <p className="text-[10px] font-sans text-stone-400 truncate mt-0.5">
                {style.desc}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
